var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('button',{staticClass:"ontario-button ontario-button--secondary mb-5",attrs:{"disabled":_vm.nextDisabled()},on:{"click":_vm.nextPage}},[_vm._v(_vm._s(_vm.changeButtonText))])])}
var staticRenderFns = []

export { render, staticRenderFns }